import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const loadMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    loadMe();
    const onLogout = () => setUser(false);
    window.addEventListener("bo:logout", onLogout);
    return () => window.removeEventListener("bo:logout", onLogout);
  }, [loadMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (!data.mfa_required) setUser(data);
    return data;
  };
  const verifyMfa = async (mfa_token, code) => {
    const { data } = await api.post("/auth/mfa/login", { mfa_token, code });
    setUser(data);
    return data;
  };
  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    setUser(data);
    return data;
  };
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, login, verifyMfa, register, logout, reload: loadMe }}>{children}</AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
